import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import {
  resolveCategoryOptionColors,
  toPaletteColorName,
  type CategoryOptionColors,
} from '../lib/paletteLookup';

/**
 * Returns a function that resolves a category's fill (background/hover/text)
 * through the surrounding experience's colorPalette and bold/light colorMode
 * (child planner pages resolve the parent's). Takes the category's persisted
 * colorName, normalizing unknown/missing values to the default slot. Must
 * render within a PageExperienceContext.
 */
export const useCategoryOptionColorsResolver = () => {
  const context = usePageExperienceContext();
  const experience = context.parentExperience ?? context.experience;
  const paletteId = experience.colorPalette;
  const colorMode = experience.colorMode;

  return (colorName: string | null | undefined): CategoryOptionColors =>
    resolveCategoryOptionColors(
      toPaletteColorName(colorName),
      paletteId,
      colorMode
    );
};
